<div *ngIf="item.allowed_types.length > 1">
  <label [for]="item.name"
    >{{ "select_type" | translation
    }}<span *ngIf="item.required">*</span></label
  >
  <p-select
    [required]="item.required"
    [placeholder]="'select_type' | translation"
    [options]="item.allowed_types"
    [(ngModel)]="type"
    optionLabel="name"
    optionValue="name"
    (onChange)="getDataItems(type)"
    [disabled]="checkDisable()"
  />

  <!-- <nb-form-field
    *ngIf="type && type.length > 0"> -->
  <label [for]="item.name">
    {{
      item.translation_key || item.label || "select_item"
        | translation
        | translationFromString
        | transformText : item?.text_transform
    }}
    <span *ngIf="item.required">*</span>
  </label>

  <p-select
    [required]="item.required"
    [placeholder]="
      item.translation_key || item.label || 'select_item' | translation
    "
    [options]="item.allowed_types"
    [(ngModel)]="value"
    optionLabel="name"
    optionValue="name"
    (onChange)="getDataItems(type)"
    [disabled]="checkDisable()"
  >
    <ng-template #selectedItem let-selectedOption>
      {{ selectedOption.label }}
    </ng-template>

    <ng-template let-op #item>
      {{ op.label }}
    </ng-template>
  </p-select>
</div>

<div
  *ngIf="
    (item.allowed_types.length == 1 && dataItems && dataItems.length > 0) ||
    item.allow_new
  "
>
  <label [for]="item.name">
    {{ item.translation_key || item.label || "select_item" | translation }}
    <span *ngIf="item.required">*</span>
  </label>

  <p-select
    [required]="item.required"
    #connectSelect
    [disabled]="checkDisable()"
    ngDefaultControl
    [(ngModel)]="value"
    [placeholder]="
      item.translation_key || item.label || 'select_item' | translation
    "
    optionLabel="title"
    optionValue="value"
    [options]="dataItemsOptions"
    (onChange)="setConnectionData($event?.value, item.setting, 'id')"
  />

  <span nbSuffix *ngIf="item.helpText" pTooltip="{{ item.helpText }}">
    <i class="fas fa-question-circle"></i>
  </span>
</div>
<div>
  <app-view
    [info]="childview[0]"
    *ngIf="childview && childview[0] && childview[0].data"
    [items]="childview[0].data.content"
    [data]="data"
    (openViewHandler)="openViewHandler($event, ite)"
    (moveHandler)="openMove()"
    (openLinkHandler)="openLinkHandler($event, ite)"
  >
  </app-view>
  {{ childview }}
</div>
